import React from 'react'
import Sphone from '../../Assets/images/gf.png'
import Phone from '../../Assets/images/gf.png'
import Constant from '../../Constant'
import Button from '../SelectValue/Button'
function TopSec() {
  return (
    <div className=' pt-20 px-2 md:px-0   w-full'>
        <div className=' px-5  md:px-10  grid lg:grid-cols-2 gap-4'>
            <div className='md:flex-col wow  animate__animated animate__fadeInLeft flex justify-center  md:pl-10 md:w-11/12 pt-6 '>
            <div>
               
                <div className=' mt-6 '>
                    <h1 className=' text-[24px] md:text-[48px] font-[800]'>Want to raise funds for your <span className=' text-primary-color'> Real estate projects?</span></h1>
                    </div>
                    <p className=' text-[#1A1A1B] '>You have a good investment idea and a reasonable track record, but you are lacking necessary capital?</p>
                 <div className=' mt-10 md:flex'> 
                    <div className='flex justify-center mt-3 md:mt-0 '>
                    <a href={Constant.BASE_LINK_URL + '/'} target='_blank' rel="noreferrer">
                       <Button
                        name='Start now'
                       />
                       </a>
                    </div>
                   
                </div>
            </div>
            </div>
            <div className=' md:pt-[52px] relative flex justify-center '>
                    <img src={Phone} className='hidden wow animate__zoomInUp animate__animated md:block ' alt='Phone'/>
                    <img src={Sphone} className='md:hidden wow animate__zoomInUp animate__animated block ' alt='Phone'/>
            </div>
        </div>
    </div>
  )
}

export default TopSec